module.exports = __webpack_public_path__ + "media/images/icons/resources-purple-28ee10388b650449f08c2d244d1e5135.svg";